import { RealtimeTenantService } from '@queimadiaria/tenant-connection-front';

import { env } from 'src/app/env';

export function getTenantResourceService() {
  return RealtimeTenantService.getTenantResourceService(
    env.TENANT_ID || '',
    env.IS_TENANT_DEVELOPMENT ? 'development' : 'production'
  );
}

export function getBaseResourceUrl(): string {
  const tenantResourceService = getTenantResourceService();
  return tenantResourceService.getBaseResourceUrl();
}
